import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  type: true,
};

const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    setType: (state, action) => {
      state.type = action.payload;
    },
  },
});

export const { setType } = appSlice.actions;
export default appSlice.reducer;
